<app-license-info></app-license-info>
